// extracted by mini-css-extract-plugin
module.exports = {"iframeWrapper":"style_iframeWrapper__s99Ia","iframe":"style_iframe__0xThi"};